import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function NewArrivals() {
  const newComics = comics.filter((c) => c.isNew);

  return (
    <section className="py-14 md:py-20 bg-background-100/70">
      <div className="mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-4 py-1.5 border border-background-300 rounded-full text-foreground-600 text-xs font-medium mb-4 whitespace-nowrap">
              新作上架
            </span>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
              最新上架的
              <span className="block">韩国漫画</span>
            </h2>
          </div>
          <Link
            to="/category/all?sort=newest"
            className="text-foreground-500 hover:text-foreground-900 text-sm flex items-center gap-1 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {newComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 免费韩漫大全新作`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 bg-accent-500 text-white text-[10px] font-medium rounded-full whitespace-nowrap">
                    NEW
                  </span>
                </div>
              </div>
              <h3 className="text-foreground-900 font-medium text-sm mb-1 line-clamp-1">{comic.title}</h3>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span>{comic.author}</span>
                <span>·</span>
                <span>{comic.category}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}